import { render, staticRenderFns } from "./list.vue?vue&type=template&id=18988306&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18988306",
  null
  
)

export default component.exports